import { render, staticRenderFns } from "./EscalRule.vue?vue&type=template&id=1c45fa70&"
import script from "./EscalRule.vue?vue&type=script&lang=js&"
export * from "./EscalRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports